<template>
    <Modal
      v-if="show"
      dimmed
      :width="95"
    >
      <div class="form-container card-shape modal-window">
        <h2 class="form-field-header" v-translate>Action Required</h2>
        <div class="form-field" style="margin-bottom: 0;">
          <translate>You must complete all enrollment questionnaires before continuing.</translate>
        </div>
        <div class="form-footer">
          <div class="button-container">
            <button class="form-button" @click="$router.push({ name: 'RequiredOnboardingSurveys' })">Continue Enrollment</button>
          </div>
        </div>
      </div>
    </Modal>
</template>

<script>
import Modal from '@/components/Modal'

export default {
  name: 'RequiredOnboardingSurveysModal',
  components: {
    Modal,
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/flex-box';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
@import '@/styles/grant-circles';
</style>
